/**
 * URL Processing Layer
 * 
 * RULE: /api only exists in .env files, never added in code
 * - .env: VITE_API_URL=http://localhost:3000/api
 * - .env.production: VITE_API_URL=https://api.betfol.io/api
 */

// Get base URL from environment (already includes /api)
const API_BASE = import.meta.env.VITE_API_URL;

// API URL builder (used by api.ts)
export function getApiBaseUrl(): string {
  return API_BASE;
}

// Full URL builder (used for redirects like Google OAuth)
export function buildFullUrl(path: string): string {
  // Remove leading/trailing slashes
  const cleanPath = path.replace(/^\/+|\/+$/g, '');
  // Never add /api, it's already in API_BASE
  return `${API_BASE}/${cleanPath}`;
}